import { observer } from "mobx-react";
import React from "react";

import { NavLink } from "react-router-dom";

import { useRootAppStore } from "@hooks";
import { THEME_SETTINGS } from "@theme-settings";
import classNames from "classnames";

export default observer(function AccountSettingsCRCItem(props: {
	path: string;
	translation: string;
}) {
	const rootStore = useRootAppStore();

	if (!THEME_SETTINGS.isCreditRatingCheckEnabled) {
		return null;
	}

	if (!rootStore.userAuthStore.isInternetUser) {
		return null;
	}

	return (
		<li className="nav--tertiary__item">
			<NavLink
				to={props.path}
				className="nav--tertiary__link"
				activeClassName="is-active"
				isActive={(_, location) =>
					location.pathname.includes(props.path)
				}
			>
				<span className="nav--tertiary__title">
					{props.translation}
				</span>

				<i
					className={classNames("u-icon u-icon--sml", {
						"u-icon--alert-circle--bold u-color--sent--warning":
							rootStore.userAuthStore.user?.isInternetUser
								? rootStore.userAuthStore.user
										?.isCreditRatingCheckRequired
								: rootStore.userAuthStore.secondaryUser
										?.isCreditRatingCheckRequired,
						"u-icon--check-circle--bold u-color--sent--success":
							rootStore.userAuthStore.user?.isInternetUser
								? !rootStore.userAuthStore.user
										?.isCreditRatingCheckRequired
								: !rootStore.userAuthStore.secondaryUser
										?.isCreditRatingCheckRequired,
					})}
				/>
			</NavLink>
		</li>
	);
});
